//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { PLEASE_CHECK_BACK_VERY_SOON, THERE_ARE_NO_JOB_LISTINGS_TO_DISPLAY_AT_THE_MOMENT } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        // root: {
        //     display: 'flex',
        //     flexDirection: 'column',
        //     justifyContent: 'center',
        //     alignItems: 'space-evenly',
        //     height: '100%',
        // },
        root: {
            overflowY: 'hidden',
            display: 'flex',
            padding: '30px',
            // paddingBottom: 0,
            flexDirection: 'row',
            backgroundColor: '#fff',
            marginLeft: '20px',
            marginTop: 10, // on Brand Page, align with SideBar
            borderRadius: '10px',
            height: '100%',
        },
        container: {
            height: '100%',
            // overflow: 'hidden',
            paddingRight: '8px', // temp fix
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        },
        icon: {
            width: '100%',
            fontSize: 140,
            color: '#F0F2F6',
            marginBottom: 27,
        },
        text1: { textAlign: 'center', fontWeight: 600, marginBottom: 8 },
        text2: { textAlign: 'center', fontSize: 15 },
        hidden: {
            display: 'none',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props
    } = params;
    // const { hidden: hiddenCls } = classes;

    const defns = {
        // noThreadMessageIcon: {},
        text1: {
            variant: 'h6',
            value: THERE_ARE_NO_JOB_LISTINGS_TO_DISPLAY_AT_THE_MOMENT,
        },
        text2: {
            variant: 'body2',
            value: PLEASE_CHECK_BACK_VERY_SOON,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const JobListingNotAvailableYet = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { isHidden } = props;

    //---------------------------------------------------------------------
    // useCallback hook
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return isHidden ? null : (
        <div {...defns.root}>
            <div {...defns.container}>
                <SearchIcon {...defns.icon} />
                <AfitdTypography {...defns.text1} />
                <AfitdTypography {...defns.text2} />
            </div>
        </div>
    );
};

export default JobListingNotAvailableYet;
